import { render, staticRenderFns } from "./RouteChannelInfo.vue?vue&type=template&id=28750f6e&scoped=true&"
import script from "./RouteChannelInfo.vue?vue&type=script&lang=js&"
export * from "./RouteChannelInfo.vue?vue&type=script&lang=js&"
import style0 from "./RouteChannelInfo.vue?vue&type=style&index=0&id=28750f6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28750f6e",
  null
  
)

export default component.exports